import { AppName } from 'models';
import { AppHelpers } from 'helpers/AppHelpers';

import { SessionStorageService } from 'services/SessionStorageService';
import { currentAppState } from 'state/current-app';

const CurrentAppService = {
    setActive: (app: AppName, userId?: string | null) => {
        const lastActiveApp = { app, userId };

        currentAppState.lastActiveApp = lastActiveApp;
        SessionStorageService.store(AppHelpers.storageKey.lastActiveApp, lastActiveApp);
    },
};

export { CurrentAppService };
